<div class="global-container">
  
  <mat-card class="global-filters-card">
    
    <mat-card-content class="filters-container">
        <mat-form-field appearance="outline">
            <mat-label>{{languageService.Strings.buttons.button_dateRange}}</mat-label>
            <mat-date-range-input [rangePicker]="picker" (click)="picker.open()">
                <input matStartDate readonly [(ngModel)]="globalFilters.startDate">
                <input matEndDate readonly [(ngModel)]="globalFilters.endDate">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{languageService.Strings.buttons.button_targetRegion}}</mat-label>
            <mat-select [(ngModel)]="globalFilters.region">
            <mat-option *ngFor="let region of optionMenu_Region_OptionList" [value]="region">
                {{ languageService.Strings.regions[region] }}
            </mat-option>
        </mat-select>
        </mat-form-field>

    </mat-card-content>
  </mat-card>

  <mat-divider class="divider"></mat-divider>

  <div class="queries-grid">

    <mat-card class="query-card">
      <mat-card-header>
        <mat-card-title class="custom-title">{{languageService.Strings.messages.cardTitle_userAnalysisCount}}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{languageService.Strings.messages.input_box_email}}</mat-label>
          <input matInput type="email" placeholder="ejemplo@email.com" [(ngModel)]="inputs.userEmail">
        </mat-form-field>
      </mat-card-content>
      <mat-card-actions>
        <button mat-flat-button color="primary" (click)="getUserAnalysisCount()"
          [disabled]="!valid_getUserAnalysisCount()"
          >
            {{languageService.Strings.buttons.button_accept}}
        </button>
        <span class="result-text highlight" *ngIf="results.userCount !== null">{{ results.userCount }}</span>
      </mat-card-actions>
    </mat-card>

    <mat-card class="query-card">
      <mat-card-header>
        <mat-card-title class="custom-title">{{languageService.Strings.messages.cardTitle_domainAnalysisCount}}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{languageService.Strings.messages.input_box_domain}}</mat-label>
          <input matInput type="text" placeholder="artisdevelopment.com" [(ngModel)]="inputs.domainNameCount">
        </mat-form-field>
      </mat-card-content>
      <mat-card-actions>
        <button mat-flat-button color="primary" (click)="getDomainAnalysisCount()"
          [disabled]="!valid_getDomainAnalysisCount()"
          >
            {{languageService.Strings.buttons.button_accept}}
        </button>
        <span class="result-text highlight" *ngIf="results.domainCount !== null">{{ results.domainCount }}</span>
      </mat-card-actions>
    </mat-card>

    <mat-card class="query-card">
      <mat-card-header>
        <mat-card-title class="custom-title">{{languageService.Strings.messages.cardTitle_domainActivity}}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{languageService.Strings.messages.input_box_domain}}</mat-label>
          <input matInput type="text" placeholder="artisdevelopment.com" [(ngModel)]="inputs.domainNameActivity">
        </mat-form-field>
      </mat-card-content>
      <mat-card-actions>
        <button mat-flat-button color="accent" (click)="getDomainActivity()"
          [disabled]="!valid_getDomainActivity()"
        >
          <mat-icon>download</mat-icon> 
          {{languageService.Strings.buttons.button_download}}
        </button>
      </mat-card-actions>
    </mat-card>

    <mat-card class="query-card">
      <mat-card-header>
        <mat-card-title class="custom-title">{{languageService.Strings.messages.cardTitle_globalAnalysisCount}}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p class="description-text">{{languageService.Strings.messages.cartText_analysisCount}}</p>
      </mat-card-content>
      <mat-card-actions>
        <button mat-flat-button color="primary" (click)="getGlobalAnalysisCount()"
          [disabled]="!valid_getGlobalAnalysisCount()"  
        >
            <mat-icon>download</mat-icon>
            {{languageService.Strings.buttons.button_download}}
        </button>
        <span class="result-text highlight" *ngIf="results.globalCount !== null">{{ results.globalCount }}</span>
      </mat-card-actions>
    </mat-card>
    

  </div>
</div>


<!-- Waiting spinner -->
<div *ngIf="(displayWaitingPopup)" >
    <app-waiting-popup [waitingMessage]="waitingMessage" ></app-waiting-popup> 
</div>